import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLoanVariablesDialogState } from 'store/selectors/loanVariablesDialog.selector';
import { SetFieldValue } from 'modules/core/types/form';

import { LOAN_VARIABLES_FIELDS_NAMES } from '../../consts/fieldNames.const';
import { updateBalloonPaymentFormValues } from '../BalloonPayment.service';

export const useBalloonVehicleInfoFetchedCallback = (
  isLender: boolean,
  balloonToggle: boolean,
  handleChangeCallback: Function,
  setValue: SetFieldValue,
  overrideFormHistoryValues: Function,
  onBalloonValuesApplied?: () => void,
) => {
  const { balloonVehicleInfoFlags, balloonVehicleInfo, selectedBalloonVehicle } = useSelector(
    getLoanVariablesDialogState,
  );

  useEffect(() => {
    if (isLender && balloonVehicleInfoFlags.isLoaded) {
      updateBalloonPaymentFormValues(selectedBalloonVehicle, balloonVehicleInfo, setValue, overrideFormHistoryValues);

      const notifyApplied = () => onBalloonValuesApplied?.();

      if (balloonToggle) {
        Promise.resolve(handleChangeCallback({ target: { name: LOAN_VARIABLES_FIELDS_NAMES.BALLOON_TOGGLE } })).then(
          notifyApplied,
          notifyApplied,
        );
      } else {
        notifyApplied();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balloonVehicleInfoFlags.isLoaded]);
};
